import { useEffect } from "react";

let currentGtmId = null;
const setGTMIdScript = (newGtmId) => {
    //if script already available with same gtm then return 
    if (currentGtmId === newGtmId && document.getElementById("gtm-script")) {
        return;
    }
    if (currentGtmId !== newGtmId) {
        //if scripts available then remove it first
        if (document.getElementById("gtm-script")) {
            document.getElementById("gtm-script")?.remove();
        }
        if (document.getElementById("gtm-noscript")) {
            document.getElementById("gtm-noscript")?.remove();
        }

        const script = document.createElement("script");
        script.id = "gtm-script";
        script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; 
          w[l].push({
            'gtm.start': new Date().getTime(), event: 'gtm.js'
          }); 
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), 
              dl = l != 'dataLayer' ? '&l=' + l : ''; 
          j.async = true; 
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${newGtmId}');`;
        document.head.appendChild(script);

        const noscript = document.createElement("noscript");
        noscript.id = "gtm-noscript";
        noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${newGtmId}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.prepend(noscript);

        currentGtmId = newGtmId; // setting new gtm id as current gtm id
    }
}

export const useGTM = () => {

    const setGtm = (gtmId) => {
        if (!gtmId || typeof window === "undefined") return;
        setGTMIdScript(gtmId);
    }
    return { setGtm };
    // useEffect(() => {
    //     if (!gtmId) return;

    //     // Prevent duplicate script
    //     if (!document.getElementById("gtm-script")) {
    //         const script = document.createElement("script");
    //         script.id = "gtm-script";
    //         script.innerHTML = `
    //     (function (w, d, s, l, i) {
    //       w[l] = w[l] || []; 
    //       w[l].push({
    //         'gtm.start': new Date().getTime(), event: 'gtm.js'
    //       }); 
    //       var f = d.getElementsByTagName(s)[0],
    //           j = d.createElement(s), 
    //           dl = l != 'dataLayer' ? '&l=' + l : ''; 
    //       j.async = true; 
    //       j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
    //       f.parentNode.insertBefore(j, f);
    //     })(window, document, 'script', 'dataLayer', '${gtmId}');
    //   `;
    //         document.head.appendChild(script);
    //     }

    //     // Prevent duplicate noscript
    //     if (!document.getElementById("gtm-noscript")) {
    //         const noscript = document.createElement("noscript");
    //         noscript.id = "gtm-noscript";
    //         noscript.innerHTML = `
    //     <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
    //         height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    //         document.body.prepend(noscript);
    //     }
    // }, [gtmId]);
};
